export default "__VITE_ASSET__CibhxSgi__"